import { getIsApiPending, getUpdateForm } from '../../../selectors/eaTravelRates/update';
import { apiTransitionTriggerUpdate, triggerUpdateSuccess } from '../../../actions/eaTravelRates/update';
import axios from 'axios';
import { getAuthVerifyData } from '../../../selectors/eaTravelRates/auth';

export const updateService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionTriggerUpdate.pending());
            try {
                const resp = await calculate(store.getState());

                store.dispatch(triggerUpdateSuccess(resp.data));
                store.dispatch(apiTransitionTriggerUpdate.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionTriggerUpdate.failure());
            }
        }
    })();
    return next(action);
};

const payload = (state) => {
    const updateDetails = getUpdateForm(state);

    const countryCode = process.env.GATSBY_COUNTRY_SELECTOR.toUpperCase();

    const payload = {
        fromCurrency: updateDetails.fromCurrency.value,
        toCurrency: updateDetails.toCurrency.value,
        rate: Number(updateDetails.exchangeRate.value),
        countryCode,
    };

    return {
        ...payload,
    };
};

const calculate = async (state) => {
    const loginData = getAuthVerifyData(state);
    try {
        const url = '/om-api/ea-travel-rates/update';
        return await axios.post(url, payload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
